import { Resources } from 'constants/resources';

import Percent from '@mui/icons-material/Percent';
import { useRecordContext } from 'react-admin';
import { LinkButton } from 'shared/mui/Buttons';
import { Provider } from 'types/embedded/provider';

export const ProvidersListDatagridCommissionsField: React.FC = () => {
  const record = useRecordContext<Provider>();

  if (!record) {
    return <></>;
  }

  return record.commissionsCount ? (
    <LinkButton
      label="Перейти"
      pathParams={{ resource: Resources.Commissions, type: 'list' }}
      queryParams={{
        filter: {
          provider: [record.id],
        },
      }}
      startIcon={<Percent />}
    />
  ) : (
    <LinkButton
      label="Добавить"
      pathParams={{ resource: Resources.Commissions, type: 'create' }}
      queryParams={{
        filter: {
          provider: record.id,
        },
      }}
      startIcon={<Percent />}
    />
  );
};
